import { render, staticRenderFns } from "./ArchivesDownload.vue?vue&type=template&id=29d36980&"
import script from "./ArchivesDownload.vue?vue&type=script&lang=js&"
export * from "./ArchivesDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports